export const isOptionGroup = (optionOrOptionGroup) => {
    return 'options' in optionOrOptionGroup;
};
